// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './vuex/store'

Vue.use(Vuex)
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import VueLazyLoad from 'vue-lazyload'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'
import api from './api/index'
import VueCookies from 'vue-cookies'


Vue.prototype.$api = api
Vue.use(require('vue-wechat-title'))
Vue.use(Vant);
Vue.use(VueCookies)
Vue.prototype.$cookies = VueCookies
// Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(VueLazyLoad,{
  error:'/static/errorimg1.png',
  loading:'/static/loadingimg.png'
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js